(function () {
  function formatMoney(cents, moneyFormat) {
    const value = Number(cents);
    if (!Number.isFinite(value)) return '';

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try {
        return window.Shopify.formatMoney(value, moneyFormat || undefined);
      } catch (_err) {
        /* fall through */
      }
    }

    const amount = (value / 100).toFixed(2).replace(/\.00$/, '');
    return 'A$' + amount;
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function firstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;
    return (
      product.variants.find((variant) => variant && variant.available) ||
      product.variants[0] ||
      null
    );
  }

  function productImage(product, variant) {
    const featured = product && product.featured_image;
    if (featured) {
      if (typeof featured === 'string') return featured.startsWith('//') ? 'https:' + featured : featured;
      if (featured.src) {
        return featured.src.startsWith('//') ? 'https:' + featured.src : featured.src;
      }
    }
    if (variant && variant.featured_image && variant.featured_image.src) {
      const src = variant.featured_image.src;
      return src.startsWith('//') ? 'https:' + src : src;
    }
    if (product && Array.isArray(product.images) && product.images[0]) {
      const img = product.images[0];
      const src = typeof img === 'string' ? img : img.src;
      return src && src.startsWith('//') ? 'https:' + src : src;
    }
    return '';
  }

  function getCart() {
    return (
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer')
    );
  }

  async function addVariantToCart(variantId, button) {
    if (!variantId) return;

    const cart = getCart();
    button && button.setAttribute('disabled', 'disabled');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    config.body = formData;

    const addUrl =
      (window.routes && window.routes.cart_add_url) ||
      (typeof routes !== 'undefined' && routes.cart_add_url) ||
      '/cart/add';

    try {
      const response = await fetch(addUrl, config);
      const data = await response.json();

      if (data.status) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'td-field-notes-article',
            productVariantId: variantId,
            errors: data.errors || data.description,
            message: data.message,
          });
        }
        return;
      }

      if (!cart) {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'td-field-notes-article',
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      if (typeof cart.renderContents === 'function') cart.renderContents(data);
    } catch (error) {
      console.error(error);
    } finally {
      button && button.removeAttribute('disabled');
    }
  }

  function getSwapOptions(root) {
    return {
      label: root.dataset.tdSwapLabel || 'the swap',
      mediaTag: root.dataset.tdSwapMediaTag || '',
      description: root.dataset.tdSwapDescription || '',
      buttonLabel: root.dataset.tdSwapButton || 'add to cart',
      moneyFormat: root.dataset.tdMoneyFormat || '',
    };
  }

  function renderProductBox(el, product, options) {
    const opts = options || {};
    const variant = firstAvailableVariant(product);
    const image = productImage(product, variant);
    const title = product.title || '';
    const desc =
      opts.description ||
      (product.description || '')
        .replace(/<[^>]+>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 160);
    const price = formatMoney(variant ? variant.price : product.price, opts.moneyFormat);
    const url = product.url || `/products/${product.handle}`;
    const available = !!(variant && variant.available);
    const variantId = variant ? variant.id : '';
    const mediaTag = opts.mediaTag || '';
    const label = opts.label || 'the swap';
    const buttonLabel = opts.buttonLabel || 'add to cart';

    el.classList.remove('is-loading', 'is-error');
    el.innerHTML = `
      <div class="td-product__label">${escapeHtml(label)}</div>
      <div class="td-product__grid">
        <div class="td-product__media">
          ${
            image
              ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy" width="400" height="400">`
              : ''
          }
          ${mediaTag ? `<span class="td-product__media-tag">${escapeHtml(mediaTag)}</span>` : ''}
        </div>
        <div class="td-product__content">
          <h3 class="td-product__title"><a href="${escapeHtml(url)}">${escapeHtml(title)}</a></h3>
          ${desc ? `<p class="td-product__desc">${escapeHtml(desc)}</p>` : ''}
          <div class="td-product__row">
            <div class="td-product__price">${escapeHtml(price)}</div>
            <button
              type="button"
              class="td-product__btn"
              data-td-product-add
              data-variant-id="${escapeHtml(variantId)}"
              ${available ? '' : 'disabled'}
            >
              ${escapeHtml(available ? buttonLabel : 'Sold out')}
            </button>
          </div>
        </div>
      </div>
    `;

    const btn = el.querySelector('[data-td-product-add]');
    if (btn && available) {
      btn.addEventListener('click', () => addVariantToCart(btn.dataset.variantId, btn));
    }
  }

  async function hydrateProductBox(el, options) {
    if (el.dataset.tdProductReady) return;

    const handle = (el.getAttribute('data-handle') || '').trim();
    if (!handle) return;

    el.dataset.tdProductReady = 'true';
    el.classList.add('is-loading');

    try {
      const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
      if (!response.ok) throw new Error(`Product fetch failed (${response.status})`);
      const product = await response.json();
      renderProductBox(el, product, options);
    } catch (error) {
      console.error(error);
      el.classList.remove('is-loading');
      el.classList.add('is-error');
    }
  }

  function initCopyLink(root) {
    const btn = root.querySelector('[data-td-art-copy]');
    if (!btn || btn.dataset.tdArtCopyReady) return;
    btn.dataset.tdArtCopyReady = 'true';

    const iconLink = btn.querySelector('[data-td-art-icon-link]');
    const iconCheck = btn.querySelector('[data-td-art-icon-check]');

    btn.addEventListener('click', async () => {
      const url = btn.dataset.url || window.location.href;

      try {
        await navigator.clipboard.writeText(url);
      } catch {
        const input = document.createElement('input');
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
      }

      btn.classList.add('is-copied');
      if (iconLink) iconLink.hidden = true;
      if (iconCheck) iconCheck.hidden = false;

      window.setTimeout(() => {
        btn.classList.remove('is-copied');
        if (iconLink) iconLink.hidden = false;
        if (iconCheck) iconCheck.hidden = true;
      }, 2000);
    });
  }

  function initArticle(root) {
    const options = getSwapOptions(root);
    initCopyLink(root);

    // Only hydrate boxes that already exist in article HTML with class + handle.
    root.querySelectorAll('.td-product[data-handle]').forEach((el) => {
      hydrateProductBox(el, options);
    });
  }

  function init() {
    document.querySelectorAll('[data-td-field-notes-article]').forEach(initArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
